import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';

const API = '/api';

function getStored() {
  try {
    const t = localStorage.getItem('nasati_token');
    const u = localStorage.getItem('nasati_user');
    if (t && u) return { token: t, user: JSON.parse(u) };
  } catch (e) {}
  return null;
}

function storeAuth(token, user) {
  localStorage.setItem('nasati_token', token);
  localStorage.setItem('nasati_user', JSON.stringify(user));
}

function apiFetch(path, options = {}) {
  const auth = getStored();
  const headers = { 'Content-Type': 'application/json', ...options.headers };
  if (auth) headers['Authorization'] = 'Bearer ' + auth.token;
  return fetch(API + path, { ...options, headers });
}

const styles = {
  page: {
    minHeight: '100vh',
    background: '#f0fdfa',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'system-ui, sans-serif',
    direction: 'rtl',
    textAlign: 'right',
  },
  card: {
    background: '#fff',
    padding: 32,
    borderRadius: 16,
    boxShadow: '0 4px 20px rgba(15, 118, 110, 0.15)',
    width: '100%',
    maxWidth: 360,
    textAlign: 'right',
  },
  title: { color: '#0f766e', fontSize: 28, marginBottom: 8, textAlign: 'right' },
  subtitle: { color: '#64748b', marginBottom: 24, textAlign: 'right' },
  form: { display: 'flex', flexDirection: 'column', gap: 12 },
  input: {
    padding: 14,
    borderRadius: 8,
    border: '1px solid #e2e8f0',
    fontSize: 16,
    textAlign: 'right',
    direction: 'rtl',
  },
  error: { color: '#dc2626', fontSize: 14, textAlign: 'right' },
  success: { color: '#0f766e', fontSize: 14, textAlign: 'right', marginBottom: 8 },
  button: {
    background: '#0f766e',
    color: '#fff',
    border: 'none',
    padding: 14,
    borderRadius: 8,
    fontSize: 16,
    fontWeight: 600,
    cursor: 'pointer',
    textAlign: 'right',
  },
  linkBtn: {
    background: 'none',
    border: 'none',
    color: '#0f766e',
    cursor: 'pointer',
    fontSize: 14,
    marginTop: 12,
    textAlign: 'right',
  },
  termsNote: { fontSize: 12, color: '#64748b', marginTop: 16, textAlign: 'right' },
  termsLink: { color: '#0f766e', fontWeight: 600, textDecoration: 'none' },
};

export default function Login({ onLogin }) {
  const navigate = useNavigate();
  const location = useLocation();
  const message = location.state?.message;

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [setPasswordMode, setSetPasswordMode] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await apiFetch('/auth/login', {
        method: 'POST',
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Login failed');
      storeAuth(data.token, data.user);
      onLogin();
      navigate('/reports');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSetPassword = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await apiFetch('/auth/set-password', {
        method: 'POST',
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Failed');
      setSetPasswordMode(false);
      setPassword('');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="nasati-page" style={styles.page}>
      <div className="nasati-card" style={styles.card}>
        <h1 className="nasati-title" style={styles.title}>נסעתי</h1>
        <p style={styles.subtitle}>{setPasswordMode ? 'הגדרת סיסמה לכניסה לאתר' : 'כניסה לפורטל דוחות'}</p>
        {message && <p style={styles.success}>{message}</p>}
        <form className="nasati-form" onSubmit={setPasswordMode ? handleSetPassword : handleSubmit} style={styles.form}>
          <input
            type="email"
            placeholder="אימייל"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="nasati-input"
            style={styles.input}
            required
          />
          <input
            type="password"
            placeholder={setPasswordMode ? 'סיסמה חדשה' : 'סיסמה'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="nasati-input"
            style={styles.input}
            required
          />
          {error && <p style={styles.error}>{error}</p>}
          <button type="submit" className="nasati-button" style={styles.button} disabled={loading}>
            {loading ? '...' : setPasswordMode ? 'שמור סיסמה' : 'כניסה'}
          </button>
        </form>
        {!setPasswordMode && (
          <button
            type="button"
            onClick={() => { setSetPasswordMode(true); setError(''); }}
            style={styles.linkBtn}
          >
            עדיין לא הגדרת סיסמה? לחץ כאן
          </button>
        )}
        {setPasswordMode && (
          <button
            type="button"
            onClick={() => { setSetPasswordMode(false); setError(''); }}
            style={styles.linkBtn}
          >
            חזרה לכניסה
          </button>
        )}
        <p style={styles.termsNote}>
          <Link to="/terms" style={styles.termsLink}>תנאי שימוש ומדיניות פרטיות</Link>
          {' '}— כניסה לאתר מהווה הסכמה לתנאים ולמדיניות הפרטיות.
        </p>
        <button type="button" style={styles.linkBtn} onClick={() => navigate('/')}>
          חזרה לדף הבית
        </button>
      </div>
    </div>
  );
}
